<template>
    <div class="add-thanphod container" id="fontLao">
        <h2 class="center-align indigo-text">ເພີ່ມຂໍ້ມູນກ່ຽວກັບບໍລິສັດ</h2>
        <form @submit.prevent="AddThanphod">
            <div class="field title">
                <label for="title">ຫົວຂໍ້ ບໍລິສັດ: </label>
                <input type="text" name="title" v-model="title" id="fontLao">
            </div>
            <div v-for="(ing, index) in ingredients" :key="index" class="field">
                <label for="ingredient">ຂໍ້ມູນບໍລິສັດ:</label>
                <input type="text" name="ingredient" v-model="ingredients[index]" id="fontLao">
                <i class="material-icons delete" @click="deleteIng(ing)">delete</i>
            </div>
            <div class="field add-ingredient">
                <label for="add-ingredient">ເພີ່ມຂໍ້ມູນ ບໍລິສັດ:</label>
                <input type="text" name="add-ingredient" @keydown.tab.prevent="addIng" v-model="another" id="fontLao">
            </div>
            <div class="field center-align">
                <p v-if="feedback" class="red-text">{{ feedback }}</p>
                <button class="btn pink" id="fontLao">ເພີ່ມຂໍ້ມູນ</button>
            </div>
        </form>
    </div>
</template>

<script>
import db from '@/firebase/init'
import slugify from 'slugify'
export default {
    name: 'AddThanphod',
    data(){
        return {
            title: null,
            another: null,
            ingredients: [],
            feedback: null,
            slug: null
        }
    },
    methods: {
        AddThanphod(){
            if(this.title){
                this.feedback = null
                // create a slug
                this.slug = slugify(this.title, {
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@]/g,
                    lower:true
                })
                db.collection('thanphods').add({
                    title: this.title,
                    ingredients: this.ingredients,
                    slug : this.slug
                }).then(() => {
                    this.$router.push({ name: 'Index'})
                }).catch(err => {
                    console.log(err)
                })
            }else {
                this.feedback = 'ທ່ານຈະຕ້ອງເພີ່ມຫົວຂໍ້ບໍລິສັດເຂົ້າກ່ອນ'
            }
        },
        addIng(){
            if(this.another){
                this.ingredients.push(this.another)
                this.another = null
                this.feedback = null
            } else {
                this.feedback = 'ທ່ານຈະຕ້ອງເພີ່ມຂໍ້ມູນບໍລິສັດເຂົ້າກ່ອນ'
            }
        },
        deleteIng(ing){
            this.ingredients = this.ingredients.filter(ingredient => {
                return ingredient != ing
            })
        }
    }
}
</script>

<style>
 #fontLao{
     font-family:phetsarath ot;
 }
 .add-thanphod{
     margin-top: 60;
     padding: 20px;
     max-width: 500px;
 }
 .add-thanphod h2{
     font-size: 2em;
     margin: 20px auto;
 }
 .add-thanphod .field{
     margin:  20px auto;
     position: relative;
 }
 .add-thanphod .delete{
     position:absolute;
     right: 0;
     bottom: 16px;
     color: #aaa;
     font-size: 1.4em;
     cursor: pointer;
 }
</style>


// WEBPACK FOOTER //
// src/components/AddThanphod.vue